import { useTranslation } from "react-i18next";

export default function CashbackTag({ amount }: { amount: number }) {
  const { t } = useTranslation();

  return (
    <div className="relative bg-green-50 text-green-700 px-1 py-2 rounded-[6px] text-[10px] font-bold flex items-center gap-1 h-[23px] hover:bg-green-100 transition-colors border border-transparent">
      <svg className="absolute inset-0 w-full h-full pointer-events-none rounded-[6px]">
        <rect
          x="0.5"
          y="0.5"
          width="calc(100% - 1px)"
          height="calc(100% - 1px)"
          rx="5.5"
          fill="none"
          stroke="#22c55e"
          strokeWidth="1"
          strokeDasharray="4 4"
          strokeDashoffset="0"
          style={{ animation: "marchingAnts 1s linear infinite" }}
        />
      </svg>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4313 3.25586L13.7819 3.7793L13.5407 6.19727L15.1364 8L13.5407 9.80273L13.7819 12.2207L11.4313 12.7432L10.2184 14.8203L7.99969 13.8818L5.78192 14.8203L4.56903 12.7432L2.21844 12.2207L2.45868 9.80273L0.863953 8L2.45868 6.19727L2.21844 3.7793L4.56903 3.25586L5.78192 1.17969L7.99969 2.11816L10.2184 1.17969L11.4313 3.25586ZM9.73798 8.66699C9.44066 8.66708 9.18752 8.77049 8.97919 8.97852C8.77083 9.18676 8.66677 9.44002 8.66669 9.7373C8.66669 10.0349 8.77096 10.2886 8.97919 10.4971C9.18746 10.7053 9.44067 10.8096 9.73798 10.8096C10.0354 10.8095 10.2884 10.7052 10.4968 10.4971C10.7052 10.2887 10.8093 10.0357 10.8093 9.73828C10.8093 9.44075 10.705 9.18792 10.4968 8.97949C10.2884 8.77107 10.0354 8.66699 9.73798 8.66699ZM5.33759 9.77148L6.37177 10.8057L10.8054 6.37109L9.77118 5.33691L5.33759 9.77148ZM6.40497 5.33301C6.10751 5.33302 5.85458 5.43741 5.64618 5.64551C5.43774 5.85383 5.33369 6.10687 5.33368 6.4043C5.33368 6.70168 5.43722 6.95471 5.6452 7.16309C5.85346 7.37145 6.1067 7.47551 6.40399 7.47559C6.70155 7.47559 6.95531 7.37228 7.16376 7.16406C7.37213 6.9558 7.47619 6.70259 7.47626 6.40527C7.47626 6.10785 7.37179 5.85487 7.16376 5.64648C6.95542 5.43804 6.70241 5.33301 6.40497 5.33301Z"
          fill="#128351"
        />
      </svg>
      {amount}% {t("cashback.tag_text")}
    </div>
  );
}
